import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// material-ui
import { ButtonBase } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

// project import
import config from 'config';
import { activeItem } from 'store/reducers/menu';
import VaseelahLogo from './VaseelahLogo';
import VaseelahIcon from './VaseelahIcon';
import PriseenIcon from './PriseenIcon';
import PriseenLogo from './PriseenLogo';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = ({ sx, to, icon, iconWidth, platform = 'priseen', width }) => {
  const { defaultId } = useSelector((state) => state.menu);
  const dispatch = useDispatch();
  return platform === 'priseen' ? (
    <ButtonBase
      disableRipple
      component={Link}
      onClick={() => dispatch(activeItem({ openItem: [defaultId] }))}
      to={!to ? config.defaultPath : to}
      sx={sx}
    >
      {icon ? <PriseenIcon width={iconWidth} /> : <PriseenLogo width={width || '175'} />}
    </ButtonBase>
  ) : (
    <ButtonBase
      disableRipple
      component={Link}
      onClick={() => dispatch(activeItem({ openItem: [defaultId] }))}
      to={!to ? config.defaultPath : to}
      sx={sx}
    >
      {icon ? <VaseelahIcon width={iconWidth} /> : <VaseelahLogo />}
    </ButtonBase>
  );
};

LogoSection.propTypes = {
  sx: PropTypes.object,
  to: PropTypes.string
};

export default LogoSection;
